import {observer} from "mobx-react";
import React, {useState} from "react";
import {Alert, Button, Checkbox, Divider, Form, Input, message, Modal, notification, Radio, Result, Select} from "antd";
import moment from "moment/moment";
import axios from "axios";
import PageTitle from "./PageTitle";
import Birthdate from "./Birthdate";
import Device from "./Device";
import FromCard from "./FromCard";
import {observable} from "mobx";
import Switcher from "./Switcher";
import {callWithCatch, pp} from "../utils";
import Tourney from "@/apps/tourney/Tourney.js";

export const AddressFormFields = ({}) => {
  return <div>
    <FormDivider text="Your Address" />
    <Form.Item name="address_line1" label="Address Line1" rules={[{required: true}]}>
      <Input placeholder="e.g. 777 Main ST"/>
    </Form.Item>
    <Form.Item name="address_line2" label="Address Line2 (optional)">
      <Input placeholder="e.g. Apt 10"/>
    </Form.Item>
    <div className="columns-2">
      <Form.Item name="address_city" label="City" rules={[{required: true}]}>
        <Input placeholder="e.g. Henderson"/>
      </Form.Item>
      <Form.Item name="address_state" label="State (if applicable)" rules={[{required: !!Tourney?.njp}]}>
        <Input placeholder="e.g. NV"/>
      </Form.Item>
    </div>
    <div className="columns-2">
      <Form.Item name="address_country" label="Country" rules={[{required: true}]}>
        <Input/>
      </Form.Item>
      <Form.Item name="address_postcode" label="Zipcode" rules={[{required: true}]}>
        <Input placeholder="e.g. 12345"/>
      </Form.Item>
    </div>
  </div>
};

export const LoginStore = observable({
  view: false,
  email: null,
  redirectTo: null,
  resetToken: null,

  open: view => {
    LoginStore.view = view;
  },
  close: () => LoginStore.view = null
});

let ForgotPassword = ({}) => {
  let [loading, setLoading] = useState();
  const [form] = Form.useForm();

  let send = ({email}) => {
    callWithCatch({
      setLoading,
      url: "/password_resets",
      method: 'post',
      params: {email, back_to: location.pathname},
      onSuccess: () => {
        Modal.success({title: "Reset Password Email Sent!", content: "Check your inbox at " + email + " for a link to reset your password"});
        LoginStore.close();
      },
    })
  }

  return <div>
    <PageTitle title="Reset Password"/>
    <div className="text-center" style={{margin: "-2rem auto 2rem auto"}}>We'll send you an email with a link to reset your password</div>
    <div style={{maxWidth: "300px", margin: "0 auto"}}>
      <Form form={form} layout="vertical" onFinish={send}>
        <Form.Item name='email' label="Email" rules={[{required: true, type: 'email'}]}>
          <Input autoFocus/>
        </Form.Item>
        <Button htmlType="submit" loading={loading} block type='primary' size='large'>
          Send Reset Link
        </Button>
        <div className="text-center mt-4">
          <a onClick={() => LoginStore.view='login'} type="link">Back to login</a>
        </div>
      </Form>
    </div>
  </div>
}

let ResetPassword = observer(({}) => {
  let [loading, setLoading] = useState();
  const [form] = Form.useForm();

  let reset = ({password}) => {
    callWithCatch({
      setLoading,
      url: "/password_resets/" + LoginStore.resetToken,
      method: 'put',
      params: {password},
      onSuccess: () => {
        LoginStore.close();
        Modal.success({
          title: "Password Updated!",
          content: "You're now logged in as " + (resetUser?.name || resetUser?.email),
          onOk: () => location = location.pathname,
        });
      },
    })
  }

  let resetUser = gon.reset_user;
  if (!resetUser)
    return <Result status="warning" title="Reset link is invalid or was already used"
                   subTitle="Please request a new reset password email"
                   extra={<Button type="primary" onClick={() => LoginStore.view = 'forgot'}>Request New Link</Button>}/>;

  return <div>
    <PageTitle title={"Hello " + resetUser.name + "!"}/>
    <div className="text-center" style={{margin: "-2rem auto 2rem auto"}}>
      Choose a new password for <b>{resetUser.email}</b>.<br/>You'll be logged in right after.
    </div>
    <div style={{maxWidth: "300px", margin: "0 auto"}}>
      <Form form={form} layout="vertical" onFinish={reset}>
        <Form.Item name='password' label="New Password" rules={[{required: true}]}>
          <Input.Password autoFocus/>
        </Form.Item>
        <Form.Item name='password_confirmation' label="Confirm New Password" dependencies={['password']}
                   rules={[{required: true}, ({getFieldValue}) => ({
                     validator: (_, v) => !v || getFieldValue('password') === v ? Promise.resolve() : Promise.reject(new Error("Passwords don't match"))
                   })]}>
          <Input.Password/>
        </Form.Item>
        <Button htmlType="submit" loading={loading} block type='primary' size='large'>
          Reset Password
        </Button>
      </Form>
    </div>
  </div>
});

let ChangePassword = ({}) => {
  let [loading, setLoading] = useState();
  const [form] = Form.useForm();

  let change = async (vals) => {
    callWithCatch({
      setLoading,
      url: "/users/" + gon.user.id,
      method: 'put',
      params: vals,
      onSuccess: () => {
        message.success("Password Updated!");
        LoginStore.close();
      }
    })
  }

  return <div>
    <PageTitle title={"Change Password"}/>
    <div style={{maxWidth: "300px", margin: "0 auto"}}>
      <Form form={form} layout="vertical" onFinish={change} >
        <Form.Item name='password' label="New Password" rules={[{required: true}]}>
          <Input.Password autoFocus/>
        </Form.Item>
        <Button htmlType="submit" loading={loading} block type='primary' size='large'>
          Change Password
        </Button>
      </Form>
    </div>
  </div>
}

let MagicLink = ({}) => {
  let [loading, setLoading] = useState();
  const [form] = Form.useForm();

  let send = async () => {
    setLoading(true);
    let {email} = form.getFieldsValue();
    if (!email || !email.length || !email.match(/@/)) {
      notification.error({
        message: 'Please enter your email',
      });
      setLoading(false);

      return
    }

    callWithCatch({
      setXhr: setLoading,
      url: "/magic_links",
      method: 'post',
      params: {email, back_to: location.pathname},
      onSuccess: () => {
        Modal.success({title: "Direct Login Link Sent!", content: "Link sent to " + email});
        LoginStore.close();
      },
    })
  }

  return <div>
    <PageTitle title="Get Login Link"/>
    <div className="text-center" style={{margin: "-2rem auto 2rem auto"}}>We'll send you an email with a link to login directly</div>
    <div style={{maxWidth: "200px", margin: "0 auto"}}>
      <Form form={form} layout="vertical">
        <Form.Item name='email' label="Email" rules={[{required: true}]}>
          <Input type="email" autoFocus/>
        </Form.Item>
        <Button loading={loading} onClick={send} block type='primary' size='large'>
          Send Login Link
        </Button>
        <div className="text-center mt-4">
          <a onClick={() => LoginStore.view='login'} type="link">Back to login</a>
        </div>
      </Form>
    </div>
  </div>
}

const Confirm = observer(() => {
  let sub = [
    "Verification email sent to " + LoginStore.email,
    "Click on the verification link in the email to activate your account",
    "Make sure to check spam/junk folders!"
  ]

  return <Result
    status="success"
    title="To Activate Your Account Please Verify Your Email"
    subTitle={sub.map(d => <div key={d}>{d}</div>)}
  />;
});

const Login = observer(({setLoginView, ...props}) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  let login = async () => {
    setLoading(true);
    let data = (await axios.post("/login", form.getFieldsValue())).data;

    if (data.err) {
      notification.error({
        message: 'Login Error',
        description: data.err
      });
      setLoading(false);
    }
    else
      location = LoginStore.redirectTo || location.pathname;
  };

  return <div>
    <PageTitle title="Account Login"/>
    <div className={!Device.xs && "h-space"} style={{maxWidth: "500px", margin: "0 auto"}}>
      <Form autoComplete="off" form={form} layout="vertical">
        <FromCard title="Login">
          <Form.Item name='email' label="Email" rules={[{required: true}]}>
            <Input autoFocus/>
          </Form.Item>
          <Form.Item name='password' label="Password" rules={[{required: true}]}>
            <Input.Password/>
          </Form.Item>
          <Button loading={loading} onClick={login} block type='primary' size='large'>
            Login
          </Button>
          <center>
            <br/>
            <a onClick={() => LoginStore.view = Tourney?.njp ? 'forgot' : 'magic'} type="link">Forgot Your password?</a>
          </center>
        </FromCard>
        <br/>
      </Form>
      <div className="pl-2">
        <div>
          Don't have a PbRally account yet?
        </div>
        <a onClick={() => LoginStore.view='create'} type="link">Create an account</a>
      </div>
    </div>
  </div>
});

const FormDivider = ({text}) => <Divider style={{marginTop: "2rem"}} orientation="left" orientationMargin="0">{text}</Divider>

const CreateProfile = observer(({setLoginView, ...props}) => {
  const [minor, setMinor] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  let onBirthdateChange = s => {
    if (!s.match(/\d\d\d\d-\d\d-\d\d/)) {
      setMinor(false)
      return;
    }
    let bd = moment(s, "YYYY-MM-DD");

    const today = moment();
    const age = today.diff(bd, 'years');

    if (age > 17)
      setMinor(false);
    else
    if (age >= 13)
      setMinor("13+");
    else
    if (age >= 8)
      setMinor("8+");
    else
      setMinor("8-");
  }

  let create = async () => {
    let params = {...form.getFieldsValue()}
    let bd = moment(params.birthdate, "YYYY-MM-DD");

    if (!bd.isValid() || bd.isAfter() || bd.year() < 1930) {
      alert("Not a valid birthdate");
      return;
    }

    setLoading(true);
    params.back_to = LoginStore.redirectTo || location.pathname;
    try {
      let data = (await axios.post("/users", { user: params })).data;

      setLoading(false);
      if (data.err)
        alert(data.err);
      else {
        LoginStore.email = params.email;
        LoginStore.view = 'confirm';
      }
    }
    catch(e) {
      setLoading(false);
      notification.error({
        message: 'Error creating profile :(',
        description: "please contact support at support@pbrally.com"
      });
      throw(e);
    }
  }

  let minorEl;
  if (minor === "8-")
    minorEl = <Alert type="error" message="Children under 8 aren't allowed to register to the event." />

  if (minor === "8+")
    minorEl = <Alert type="error" message="Children under 13 aren't allowed to create an account. Please first create an adult account with adult's information, then you will be able to create a child profile for registration." />

  if (minor === "13+")
    minorEl = <div>
    <FormDivider text="Parent/Guardian Info" />
    <Form.Item name="parent_email" label="Parent/Guardian Email" rules={[{required: true}]}>
      <Input />
    </Form.Item>
    <Form.Item name="parent_fname" label="Parent/Guardian First Name" rules={[{required: true}]}>
      <Input/>
    </Form.Item>
    <Form.Item name="parent_lname" label="Parent/Guardian Last Name" rules={[{required: true}]}>
      <Input/>
    </Form.Item>
    <Form.Item name="parent_phone" label="Parent/Guardian Phone Number" rules={[{required: true}]}>
      <Input/>
    </Form.Item>
  </div>

  let addressEl;
  if (gon.reg_require_address)
    addressEl = <AddressFormFields />

  let disabled = minor === "8-" || minor === "8+";

  return <div>
    <PageTitle title="Create Your Profile"/>
    <div style={{marginTop: "-1.5rem"}}>
      <center>
        <div>In order to register, create a profile first</div>
        <div>Already have a PbRally profile? <a onClick={() => LoginStore.view='login'}>Login instead</a></div>
      </center>
    </div>
    <br/>
    <Form onFinish={create} autoComplete="off" form={form} layout="vertical" style={{maxWidth: "300px", margin: "0 auto"}} initialValues={{address_country: "United States"}}>
      <FormDivider text="Account Info" />
      <Form.Item name="email" label="Email" rules={[{required: true}]}>
        <Input autoFocus/>
      </Form.Item>
      <Form.Item name='password' label="Password" rules={[{required: true}]}>
        <Input.Password/>
      </Form.Item>
      <FormDivider text="Your Info" />
      <div className="columns-2">
        <Form.Item name="fname" label="First Name" rules={[{required: true}]}>
          <Input/>
        </Form.Item>
        <Form.Item name="lname" label="Last Name" rules={[{required: true}]}>
          <Input/>
        </Form.Item>
      </div>
      <Form.Item name="phone" label="Phone Number" rules={[{required: true}]}>
        <Input/>
      </Form.Item>
      <Form.Item name="gender" label="Gender" rules={[{required: true}]}>
        <Radio.Group>
          <Radio value='male'>Male</Radio>
          <Radio value='female'>Female</Radio>
        </Radio.Group>
      </Form.Item>
      <Form.Item name="birthdate" label="Birthdate" rules={[{ required: true }]}>
        <Birthdate onChange={onBirthdateChange}/>
      </Form.Item>
      {minorEl}
      {addressEl}
      <Form.Item valuePropName="checked" name="terms" rules={[{required: true}]}>
        <Checkbox>I agree to the <a href="/gpages/terms" target="_blank">terms of service</a></Checkbox>
      </Form.Item>
      <Button disabled={disabled} loading={loading} block htmlType="submit" type='primary' size='large'>
        Create Profile
      </Button>
    </Form>
  </div>
});

export default observer(({defLoginView, ...props}) => {
  if (!LoginStore.view)
    return null;

  let close = () => {
    LoginStore.view = false;
  }

  return <Modal visible={true} onCancel={close} footer={null} style={{top: 20}}>
    <Switcher v={LoginStore.view} vals={['login', 'create', 'confirm', 'magic', 'forgot', 'reset', 'change']}>
      <Login />
      <CreateProfile />
      <Confirm />
      <MagicLink />
      <ForgotPassword />
      <ResetPassword />
      <ChangePassword />
    </Switcher>
  </Modal>
});